/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { 
  Box, Grid, Typography
} from '@mui/material';
import StyledMuiPaper from '../../parts/surface/StyledMuiPaper';
import StyledMuiBtnBlue from '../../parts/button/StyledMuiBtnBlue';
import MuiTextField from '../../parts/textField/MuiTextField';
import MuiCheckbox from '../../parts/checkbox/MuiCheckbox';


const styles = {
  customTableHeader: {
    fontSize: '0.5rem',
    fontWeight: 'bold',
    color: '#0047A4',
    padding: '4px 10px',
    textAlign: 'center',
  },
  customTableRow: {
    fontSize: '0.5rem',
    color: '#0047A4',
  },
  ruby:{
    fontSize: '0.5rem',
  },
  flexSbC: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flexCC: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexST: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}

export default function SearchFormsDeptAndKeyWord() {

  const navigate = useNavigate();

  const handleRegistTemplate = () => {
    navigate('/regist_template');
  };

  return (
    <StyledMuiPaper sx={{ width: '70%', overflow: 'hidden', mb:1 }}>
      <Grid container sx={{ mt:1 }}>
        <Grid item xs={2} sm={2} md={2} lg={2} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box css={styles.flexST} sx={{ ml:2 }}>
            <Typography component="span" sx={{ fontSize: '0.5rem', pr: 2, display: 'inline-block' }}>対象事業部</Typography>
          </Box>
        </Grid>
        <Grid item xs={10} sm={10} md={10} lg={10}>
          <Box css={styles.flexST}>
            <MuiCheckbox
              items={['OS', 'NC']}
            />
          </Box>
        </Grid>
        {/* <Grid item xs={8} sm={8} md={8} lg={8}> */}
        <Grid item xs={2} sm={2} md={2} lg={2} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box css={styles.flexST} sx={{ ml:2 }}>
            <Typography component="span" sx={{ fontSize: '0.5rem', pr: 2, display: 'inline-block' }}>キーワード検索</Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box css={styles.flexST} sx={{ width: '100%' }}>
            <MuiTextField
              ariaLabel="mail-content"
              multiline={false}
              minRows={1}
              placeholder="キーワードを入力してください。"
              
            />
          </Box>
        </Grid>
        
        <Grid item xs={2} sm={2} md={2} lg={2}>
          <StyledMuiBtnBlue variant="contained" color="success">検索</StyledMuiBtnBlue>
        </Grid>
        <Grid item xs={2} sm={2} md={2} lg={2}>
          <StyledMuiBtnBlue variant="contained" onClick={() => handleRegistTemplate()}>新規登録</StyledMuiBtnBlue>
        </Grid>
      </Grid>
    </StyledMuiPaper>
  )
}